import Vue from 'vue'
import VueRouter from 'vue-router'
import SolicitarDiploma from '../views/SolicitarDiploma.vue'
import Diplomas from '../views/Diplomas.vue'
import Bienvenido from '../views/Bienvenido.vue'
import SecretariaCertic from '../views/SecretariaCertic.vue'
import Login from '../views/Login.vue'
import LoginCursos from '../views/LoginCursos.vue'
import DeclaracionAccesibilidad from '../views/DeclaracionAccesibilidad.vue'
import store from "../store"

Vue.use(VueRouter)


  const checkAuth = (to, from, next) => {
    // Si no está logeado, se navega al login
    if (!store.getters["token/isLogged"]) {
      window.location.href = store.getters["token/urlLoginServicios"];
    }
    next();
  };

  const routes = [
    // {
    //   path: '/',
    //   name: 'Bienvenido',
    //   component: Bienvenido,
    //   beforeEnter: checkAuth,
    // },
    // {
    //   path: '/secretariaCERTIC',
    //   name: 'SecretariaCertic',
    //   component: SecretariaCertic,
    // },
    {
      path: '/solicitarDiploma',
      name: 'SolicitarDiploma',
      component: SolicitarDiploma,
      beforeEnter: checkAuth,
    },
    {
      path: '/diplomas',
      name: 'Diplomas',
      component: Diplomas,
      beforeEnter: checkAuth,
    },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: Login
    // },
    {
      path: '/loginCursos',
      name: 'LoginCursos',
      component: LoginCursos,
    },
    {
      path: '/declaracionAccesibilidad',
      name: 'DeclaracionAccesibilidad',
      component: DeclaracionAccesibilidad,
    },
    // {
    //   path: '/suplantar',
    //   name: 'Suplantar',
    //   component: LoginCursos, //TODO hacer pag suplantacion
    //   beforeEnter: checkAuth,
    //   meta: {
    //     isAdmin: true
    //   }
    // },

]

const router = new VueRouter({
  //mode: 'history',
  routes
})
/*
router.beforeEach((to, from, next) => {
  alert(1);
  console.log(to.name);
  console.log(from.name);
  if (to.name != from.name){
    next();
  }
});
*/
// Después de cada navegación se guarda la ruta en el localStorage, excepto login.
// Para volver a la pantalla anterior tras hacer login.
router.afterEach((to) => {
  if (to.name !== "loginCursos") {
    localStorage.setItem("POSE_LOGIN_ROUTE_KEY", to.path);
  }
});

//para la navegacion duplicada cuando se clica en el mismo enlace
const routerPush = router.push
router.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
};

export default router
